module.exports = __webpack_public_path__ + "img/10.53f1fd0c.svg";